import { useEffect, useState, useCallback, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import HEADER_RSLHOME from "../../../data/header-rslhome";
import { useRouter } from 'next/router'

const MainFilterSearchBox = ({ setImage, currentTab, setCurrentTab }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const tabRefs = useRef({});

  const router = useRouter()

  const [homeFilterList, setHomeFilterList] = useState(null)

  function getMatchingObjectsByKey(value, keys) {
    return value.filter(item => keys.includes(item.key));
  }


  useEffect(() => {
    let intervalId

    const checkForData = () => {
      const storedData = localStorage.getItem('webServiceList')
      console.log('storedData', storedData)
      if (storedData) {
        try {
          const parsedData = JSON.parse(storedData)
          // const keys = ["Cab", "Flights", "Hotels", "Activities", "Holidays", "Staycations", "Buses"];
          // const result = getMatchingObjectsByKey(parsedData, keys);
          setHomeFilterList(parsedData)
          // setCurrentTab(result?.[0]?.key || 'Cab')
          clearInterval(intervalId) // ✅ Stop polling once data is set
        } catch (error) {
          console.error('Error parsing webServiceList:', error)
        }
      }
    }

    checkForData() // Initial check
    intervalId = setInterval(checkForData, 1000) // ✅ Poll every 1 sec

    return () => clearInterval(intervalId) // Cleanup
  }, [])

  const { backgroundImage } = useSelector(state => state.common)

  // const handleTabClick = useCallback((tab, index) => {
  //   setCurrentTab(tab.name);
  //   setCurrentIndex(index);
  // }, [getBannerType, callBannerBackgroundApi]);

  const handleTabClick = (tab, index) => {
    console.log('tab', tab)
    if (tab?.url !== 'cab') {
      router.push({
        pathname: `/${tab?.url}`
      })
    } else {
      router.push({
        pathname: `/`
      })
    }
  }

  useEffect(() => {
    if (tabRefs.current[currentTab]) {
      tabRefs.current[currentTab].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  }, [currentTab]);


  return (
    <>
      <div className='tabs__content js-tabs-content d-md-none pb-20'>
        <div
          className={
            'mainSearch items-center bg-white'
          }
        >

          <div className='tabs -bookmark js-tabs only-mobile-tab'>
            <div className='tabs__controls d-flex items-center js-tabs-controls'>
              {/* {homeFilterList?.map((tab, index) => ( */}
              {HEADER_RSLHOME?.services?.map((tab, index) => (
                <button
                  key={`${index}-${tab?.id}`}
                  ref={(el) => (tabRefs.current[tab?.key] = el)}
                  className={`tabs__button tabs__button_main px-30 rounded-100 fw-600 text-white js-tabs-button h-100 ${tab?.key === currentTab ? 'is-tab-el-active' : ''
                    }`}
                  onClick={() => handleTabClick(tab, index)}
                >
                  {/* <i className={`${tab.icon} text-20 `}></i> */}
                  {/* {currentIndex === index ? (
                    <img
                      src={tab.icon}
                      alt='quote'
                      width='30'
                      className='mr-10'
                    />
                  ) : (
                    ''
                  )} */}
                  {tab?.name}
                </button>
              ))}
            </div>
          </div>

        </div>
        {/* End .mainSearch */}
      </div>
      {/* End serarchbox tab-content */}
    </>
  )
}

export default MainFilterSearchBox
